import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpEvent,
  HttpResponse,
  HttpRequest,
  HttpHandler,
} from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { lang } from 'moment';

@Injectable()
export class LanguageInterceptor implements HttpInterceptor {
  language;
  constructor() {
  }
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (localStorage.getItem('lang')) {
      this.language = localStorage.getItem('lang');
    } else {
      localStorage.setItem('lang', 'ar');
      this.language = 'ar';
    }

    request = request.clone({
      withCredentials: false,
      setHeaders: {
        lang: localStorage.getItem('lang'),
        
      },
    });
    return next.handle(request).pipe(map((event: HttpEvent<any>) => {
      if (event instanceof HttpResponse) {
      }
      return event;
    }));
  }
}
